import { render, staticRenderFns } from "./modal-receipt-to-pdf.vue?vue&type=template&id=b324da00"
import script from "./modal-receipt-to-pdf.vue?vue&type=script&lang=js"
export * from "./modal-receipt-to-pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports